import { IJobTitle } from './jobTitle';
import { WorkExperienceService } from './work-experience.service';
import { Component, Inject, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-work-experience',
  templateUrl: './work-experience.component.html',
  styleUrls: ['./work-experience.component.css']
})
export class WorkExperienceComponent implements OnInit {

  industrySectors
  constructor(private workExperienceService: WorkExperienceService, @Inject(DOCUMENT) private _document: Document) { }

  present = true;
  presentJob = false;
  jobCategories
  todayDate: Date
  jobsTitle: IJobTitle[] = Array();
  public contractTypes = [];

  ngOnInit(): void {
    this.getIndustrySector();
    this.getJobTitleCategories()
    this.present;
    this.presentJob;
    this.todayDate = new Date()
  }

  onChange(data) {
    if (this.present === false) {
      this.present = true;
      this.presentJob = false;
    } else {
      this.present = false;
      this.presentJob = true;
    }
  }

  getIndustrySector() {
    this.workExperienceService.getIndustrySectors().subscribe(response => {
      this.industrySectors = response;
    })
  }

  getJobTitleCategories() {
    this.workExperienceService.getJobCategoriesList()
      .subscribe(response => {
        this.jobCategories = response['JobTitleCategory']
        this.jobsTitle = response['JobTitleCategory']
      })
  }

  async delay(ms: number) {
    await new Promise(resolve => setTimeout(resolve, ms));
    await this._document.defaultView.location.reload();
  }

  onSubmit(data) {
    // this.contractTypes = []
    this.getJobTitleCategories();
    let jobCategoryPriority
    this.jobsTitle.forEach(jobCategory => {
      if (jobCategory['name'] === data['jobCategory']) {
        jobCategoryPriority = jobCategory['priority']
      }
    });
    data.jobCategoryPriority = jobCategoryPriority
    if (!data['currentJob'] && data['endYear'] === "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please put End Year (To), its required',
      });
    } else {
      this.workExperienceService.saveExperience(data)
        .subscribe(response => {
          if (response['id'] !== null) {
            // this.getExp();
            Swal.fire(
              'Done!',
              'Work experience has been saved!',
              'success'
            ).then((result) => {
              if (result.value) {
                this.delay(100)
              }
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Fail to save',
            });
          }
        })
    }

  }

}
